export default __webpack_public_path__ + "static/media/tos.d54e54bc.png";